import { Injectable } from '@angular/core';
import { combineLatest, map, Observable } from 'rxjs';
import { NormeSpaOrdinarioFormService } from './norme-spa-ordinario/norme-spa-ordinario-form.service';
import { NormeSrlFormService } from './norme-srl/norme-srl-form.service';
import { INavbarLink } from '@shared/models/interfaces/navbar-link.interface';
import { NormeSpaMonisticoFormService } from './norme-spa-monistico/norme-spa-monistico-form.service';
import { NormeSpaDualisticoFormService } from './norme-spa-dualistico/norme-spa-dualistico-form.service';

@Injectable()
export class AmminControlloFormService {
    navbarLinks: INavbarLink[];

    isValid$: Observable<boolean>;

    constructor(
        private normeSrlFormService: NormeSrlFormService,
        private normeSpaOrdinarioFormService: NormeSpaOrdinarioFormService,
        private normeSpaDualisticoFormService: NormeSpaDualisticoFormService,
        private normeSpaMonisticoFormService: NormeSpaMonisticoFormService
    ) {
        this.navbarLinks = [
            {
                title: 'Norme sulle SRL',
                path: 'norme-srl',
                isValid$: this.normeSrlFormService.isValid$,
                form: this.normeSrlFormService.form,
            },
            {
                title: 'Norme sulle Spa a sistema ordinario',
                path: 'norme-spa-ordinario',
                isValid$: this.normeSpaOrdinarioFormService.isValid$,
                form: this.normeSpaOrdinarioFormService.form,
            },
            {
                title: 'Norme sulle Spa a sistema dualistico',
                path: 'norme-spa-dualistico',
                isValid$: this.normeSpaDualisticoFormService.isValid$,
                form: this.normeSpaDualisticoFormService.form,
            },
            {
                title: 'Norme sulle Spa a sistema monistico',
                path: 'norme-spa-monistico',
                isValid$: this.normeSpaMonisticoFormService.isValid$,
                form: this.normeSpaMonisticoFormService.form,
            },
        ];

        this.isValid$ = combineLatest(this.navbarLinks.map((e) => e.isValid$)).pipe(map((validArr) => !validArr.includes(false)));
    }
}
